import React from "react";

const Context = React.createContext();

export class SpinnerProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSpinnerShown: false,
    };

    this.timer = null;
  }

  showSpinner = (toShow) => {
    if (toShow)
      this.timer = setTimeout(
        () => this.setState({ isSpinnerShown: true }),
        500
      );
    else {
      clearTimeout(this.timer);

      this.setState({ isSpinnerShown: false });
    }
  };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const {
      state,
      showSpinner,
      props: { children },
    } = this;
    return (
      <Context.Provider value={{ ...state, showSpinner }}>
        {children}
      </Context.Provider>
    );
  }
}

export const SpinnerConsumer = Context.Consumer;
